import ScrollTabs from './ScrollTabs';

export default ScrollTabs;
